export const path = {
  home: '/',
  transactions: '/transactions',
  login: '/login',
  setting: '/setting',
  products: '/products',
  cards: '/cards',
  cms: '/customerservice',
  notFound: '*'
}
